import TitipLelang from "../../components/Section/TitipLelang";
import InfoCaready from "../../components/Section/InfoCaready";
// import TentangCaready from "../../components/Section/TentangCaready";
import { SearchSection } from "../../components/Section/SearchSection";
import { useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import withoutAuthProvider from "../../services/withoutAuthProvider";
import { useSelector } from "react-redux";
import InfoSignUp from "../../components/InfoSignUp/InfoSignUp";
import ModalLayout from "../../containers/Layouts/ModalLayout/ModalLayout";
import { useBalancedData } from "../../hooks/useStaleWhileRevalidate";

const Home = () => {
  const { push } = useHistory();
  const isLogged = useSelector((state) => state.authReducer.isLogged);
  const [showModal, setShowModal] = useState(false);

  // Cache 1 jam untuk blog - data jarang berubah
  const { data: blogs = [], isLoading } = useBalancedData(
    ["homeBlogs"],
    async () => {
      const params = {
        page: 1,
        page_size: 3,
      };
      const response = await withoutAuthProvider.getDataWithoutAuth("/api/blog", params);
      if (response?.status === 200) {
        return response?.data.data.data;
      }
      return [];
    },
    {
      cacheTime: 1000 * 60 * 60, // 1 jam cache
      staleTime: 1000 * 60 * 60, // 1 jam stale time - data tidak akan refetch selama 1 jam
      placeholderData: [], // Placeholder saat loading pertama kali
      keepPreviousData: true, // Keep previous data saat refetch
    }
  );

  // Cache 5 menit untuk popup banner - data relatif stabil
  const { data: popup = {} } = useBalancedData(
    ["homePopup"],
    async () => {
      const response = await withoutAuthProvider.getDataWithoutAuth("/api/popup");
      if (response?.status === 200) {
        return response?.data.data[0] || {};
      }
      return {};
    },
    {
      cacheTime: 1000 * 60 * 5, // 5 menit cache
      staleTime: 1000 * 60 * 5, // 5 menit stale time - data tidak akan refetch selama 5 menit
      placeholderData: {}, // Placeholder saat loading pertama kali
      keepPreviousData: true, // Keep previous data saat refetch
    }
  );

  // Auto-show popup saat data tersedia dan is_active = true
  useEffect(() => {
    if (popup?.is_active) {
      setShowModal(true);
    }
  }, [popup?.is_active]);

  return (
    <>
      <div style={{ backgroundColor: "#F9FAFB" }}>
        <SearchSection />
        {/* <TentangCaready /> */}
        <TitipLelang isLogged={isLogged} push={push} />
        <InfoCaready data={blogs} loading={isLoading} push={push} />
        <InfoSignUp />
      </div>
      {/* <Pop Up  /> */}
      {popup?.is_active ? (
        <ModalLayout show={showModal} handleClose={() => setShowModal(false)} className="w-75" type="home-banner">
          <img
            src={popup?.file_url}
            alt=""
            className="w-100 cursor-pointer homeBanner"
            onClick={() => window.open(popup?.url, "_blank")}
            // onClick={() => window.open("https://wa.me/62081278968822", "_blank")}
          />
        </ModalLayout>
      ) : null}
    </>
  );
};

export default Home;
